export const URL_TERMS_OF_USE = 'static/Terms-of-Use.pdf'
export const URL_TERMS_OF_USE_DOCDRAFTER = 'static/Document-Automation-Terms-of-Use.pdf'
export const URL_PRIVACY_POLICY = 'static/Privacy-Policy.pdf'
export const URL_TERMS_OF_USE_TRAINING = 'static/Training-Terms-of-Use.pdf'

export const URL_LINKEDIN = 'https://www.linkedin.com/company/9384209'
export const URL_FACEBOOK = 'https://www.facebook.com/FromCounselLaw'

export const URL_SOLUTIONS = 'https://info.fromcounsel.com'
export const URL_FREE_TRIAL = 'https://info.fromcounsel.com/contact-us'
export const URL_SUPPORT = 'https://info.fromcounsel.com/support'
export const URL_BLOG = 'https://blog.fromcounsel.com/'
export const URL_TEAMS = 'https://info.fromcounsel.com/team'
export const URL_CAREERS = 'https://info.fromcounsel.com/careers'
export const URL_SITEMAP = 'https://info.fromcounsel.com/sitemap'
export const URL_FAQ = 'https://help.fromcounsel.com/'
export const URL_SECURITY = 'https://info.fromcounsel.com/fc-security'
export const URL_CORPORATE = 'https://info.fromcounsel.com/fc-corporate'
export const URL_RESTRUCTURING_INSOLVENCY = 'https://info.fromcounsel.com/fc-restructuringandinsolvency'
export const URL_EMPLOYMENT = 'https://info.fromcounsel.com/fc-employment'
export const URL_DOCUMENTS = 'https://info.fromcounsel.com/fc-documents'
export const URL_TRAINING = 'https://info.fromcounsel.com/fc-learning'
export const URL_FC_EDUCATION = 'https://info.fromcounsel.com/fc-education'
export const URL_COMPANY_SECRETARY = 'https://info.fromcounsel.com/company-secretary'
export const URL_USER_GUIDES = 'https://info.fromcounsel.com/user-guides'

export const URL_DOCUMENT_AUTOMATION = 'https://solutions.fromcounsel.com/contact-us-existing-subscriber'
export const URL_DOCUMENT_REVIEW_HISTORY = 'https://solutions.fromcounsel.com/fc-documents-table-of-updates-and-amendments'

export const URL_FROMCOUNSEL_MARKETPLACE = 'https://fromcounsel.com/marketplace/'

export const URL_FC_PODCASTS = 'https://www.fromcounselpodcasts.com/'
export const URL_FC_PODCASTS_SIGN_IN = 'https://app.fromcounselpodcasts.com/users/sign_in?is_listner=true '
export const URL_FC_TRAINING_SIGN_IN = 'https://training.fromcounsel.com'

export const URL_FC_KNOWLEDGE_NOTIFY_SIGNUP = 'https://share.hsforms.com/1e4gYL01mSFODX6JFq1BiKw2vzdi?hsCtaTracking=f42e1562-3d86-47c5-8801-d9c408bdd901%7C7d90e1f9-01ee-4626-9ba1-6669b2c58973'
